import styled from 'styled-components';

const RequiredMarker = styled.span`
  &::after {
    margin-left: 5px;
    content: "*";
    color: var(--color-red);
    font-weight: bold;
    vertical-align: top;
  }
`;

export default RequiredMarker;
